import { render, staticRenderFns } from "./StrategieBagageType.vue?vue&type=template&id=40d4f6df&scoped=true"
import script from "./StrategieBagageType.vue?vue&type=script&lang=js"
export * from "./StrategieBagageType.vue?vue&type=script&lang=js"
import style0 from "./StrategieBagageType.vue?vue&type=style&index=0&id=40d4f6df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4f6df",
  null
  
)

export default component.exports